<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="onLoad"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"> </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="archiveType(scope.row)">
          档案信息
        </el-button>
        <!-- <el-button type="text" size="small" @click="datashow(scope.row)">
          动态数据展示
        </el-button> -->
        <el-button type="text" size="small" @click="datashow(scope.row)">
          动态数据达标
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        indexLabel: "序号",
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        selection: true,
        searchMenuSpan: 4,
        column: [
          {
            label: "教学资料类型",
            prop: "name",
            search: true,
            searchLabelWidth: 100,
            dicData: [
              { label: "视频", value: 0 },
              { label: "文档", value: 1 },
            ],
          },
          {
            label: "标题",
            prop: "mobile",
            search: true,
          },
          {
            label: "上传时间",
            prop: "mobile",
            search: true,
          },
          {
            label: "版本号",
            type: "select",
            search: true,
          },
          {
            label: "访问量统计",
            type: "select",
            search: true,
            searchLabelWidth: 100,
          },
          {
            label: "分类标签",
            prop: "mobile",
            search: true,
            dicData: [
              { label: "设备绑定", value: 0 },
              { label: "小程序操作", value: 1 },
            ],
          },
          {
            label: "自主学习内容更新记录",
            type: "select",
            search: true,
            searchLabelWidth: 160,
          },
        ],
      },
      data: [],
    };
  },
  computed: {},
  methods: {
    searchReset() {
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      params.vipLevel = 2;
      params.channel = window.localStorage.getItem("channel");
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    onLoad(
      page,
      params = { vipLevel: 2, channel: window.localStorage.getItem("channel") }
    ) {
      console.log("test qqq");
      console.log(params);
    },

    archiveType(row) {
      console.log(row);
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/health/archiveType",
        query: parameter,
      });
    },
  },
};
</script>
<style>
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
